import { Box } from '@mui/material'
import styles from './SecondaryNavShell.module.scss'

function SecondaryNavShell({
  isChambers = false,
  collapsedForRail = false,
  collapsedByUser = false,
  userCollapseTransition = false,
  children,
}) {
  const collapseClass = collapsedForRail
    ? styles.shellCollapsedForRail
    : collapsedByUser
      ? styles.shellUserCollapsed
      : ''
  const transitionClass = userCollapseTransition ? styles.shellUserCollapseTransition : ''
  return (
    <Box
      component="nav"
      className={`${styles.shell} ${isChambers ? styles.shellChambers : styles.shellHome} ${collapseClass} ${transitionClass}`.trim()}
    >
      {children}
    </Box>
  )
}

export default SecondaryNavShell
